import { type ApiConfig } from '../../../common/types';
import ListApiConfigItem from './ListApiConfigItem';

interface IProps {
  items: ApiConfig[];
  toggleInfoModal: () => any;
  toggleEditModal: () => any;
  toggleDeleteModal: () => any;
  handleInfoItem: (item: ApiConfig) => any;
  handleEditingItem: (item: ApiConfig) => any;
  handleDeletingItem: (item: ApiConfig) => any;
}

const ListApiConfigs: React.FC<IProps> = ({
  items: apiConfigs,
  toggleInfoModal,
  toggleEditModal,
  toggleDeleteModal,
  handleInfoItem,
  handleEditingItem,
  handleDeletingItem
}) => {
  return (
    <>
      <div className="w-full p-2 my-2 overflow-auto rounded-md">
        <table className="w-full p-4 border-b-2 border-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 pl-8 text-sm font-semibold text-left">ID</th>
              <th className="p-2 text-sm font-semibold text-left">Owner Type</th>
              <th className="p-2 text-sm font-semibold text-left">Owner Entity ID</th>
              <th className="p-2 pr-8 text-sm font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody className="">
            {apiConfigs?.map((apiConfig) => {
              return (
                <ListApiConfigItem
                  key={apiConfig.id}
                  item={apiConfig}
                  toggleInfoModal={toggleInfoModal}
                  toggleEditModal={toggleEditModal}
                  toggleDeleteModal={toggleDeleteModal}
                  handleInfoItem={handleInfoItem}
                  handleEditingItem={handleEditingItem}
                  handleDeletingItem={handleDeletingItem}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ListApiConfigs;
